module.exports = __webpack_public_path__ + "img/visa.8009e1f.png";